<template>
  <div class="share-wrapper">
    <div class="share-action" @click="expand()" :class="{'expanded' : expanded}">
      <svg width="15" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.31864 0.1997C6.59265 -0.0665666 7.03692 -0.0665666 7.31094 0.1997L10.1176 2.92697C10.3916 3.19324 10.3916 3.62494 10.1176 3.89121C9.84359 4.15748 9.39932 4.15748 9.1253 3.89121L7.51654 2.32795V9.59098C7.51654 9.94243 7.20239 10.2273 6.81487 10.2273C6.42735 10.2273 6.1132 9.94243 6.1132 9.59098V2.3278L4.50428 3.89121C4.23026 4.15748 3.78599 4.15748 3.51197 3.89121C3.23795 3.62494 3.23795 3.19324 3.51197 2.92697L6.31864 0.1997ZM1.90333 7.5C1.90333 7.12344 1.58919 6.81818 1.20167 6.81818C0.814147 6.81818 0.5 7.12344 0.5 7.5V12.9545C0.5 13.497 0.721776 14.0173 1.11654 14.4009C1.5113 14.7845 2.04672 15 2.605 15H11.025C11.5833 15 12.1187 14.7845 12.5135 14.4009C12.9082 14.0173 13.13 13.497 13.13 12.9545V7.5C13.13 7.12344 12.8159 6.81818 12.4283 6.81818C12.0408 6.81818 11.7267 7.12344 11.7267 7.5V12.9545C11.7267 13.1354 11.6527 13.3088 11.5212 13.4367C11.3896 13.5645 11.2111 13.6364 11.025 13.6364H2.605C2.41891 13.6364 2.24043 13.5645 2.10885 13.4367C1.97726 13.3088 1.90333 13.1354 1.90333 12.9545V7.5Z"/>
      </svg>
      <p>Share</p>
    </div>
    <transition name="slide">
      <div v-show="expanded" class="share-expanded">
        
        <div class="social-btn twitter" @click="share('twitter')">
          <svg width="18" height="13" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.0938 4.98436C22.1094 5.2031 22.1094 5.42188 22.1094 5.64062C22.1094 12.3125 17.0313 20 7.75001 20C4.89062 20 2.23439 19.1718 0 17.7344C0.406265 17.7812 0.796851 17.7969 1.21875 17.7969C3.57808 17.7969 5.74999 17 7.48437 15.6406C5.26562 15.5938 3.40624 14.1406 2.7656 12.1406C3.07813 12.1875 3.39061 12.2187 3.71876 12.2187C4.17187 12.2187 4.62503 12.1562 5.04688 12.0469C2.73439 11.5781 0.999959 9.54687 0.999959 7.09374V7.03126C1.67181 7.40627 2.45312 7.64064 3.28119 7.67185C1.92181 6.76558 1.03122 5.21873 1.03122 3.46871C1.03122 2.53123 1.28118 1.67186 1.7187 0.921852C4.20309 3.98435 7.93748 5.98432 12.1249 6.2031C12.0468 5.8281 11.9999 5.43752 11.9999 5.04688C11.9999 2.2656 14.25 0 17.0468 0C18.4999 0 19.8124 0.609373 20.7343 1.59375C21.8749 1.37501 22.9687 0.953114 23.9375 0.375003C23.5624 1.5469 22.7656 2.53128 21.7187 3.15624C22.7343 3.04691 23.7187 2.7656 24.6249 2.37502C23.9376 3.37498 23.0781 4.26557 22.0938 4.98436V4.98436Z"/>
          </svg>
        </div>

        <div class="social-btn facebook" @click="share('facebook')">
          <svg width="8" height="17" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0098 11.25L10.5652 7.63047H7.09219V5.28164C7.09219 4.29141 7.57734 3.32617 9.13281 3.32617H10.7117V0.244531C10.7117 0.244531 9.27891 0 7.90898 0C5.04883 0 3.1793 1.73359 3.1793 4.87188V7.63047H0V11.25H3.1793V20H7.09219V11.25H10.0098Z"/>
          </svg>
        </div>

        <div class="social-btn linkedin" @click="share('linkedin')">
          <svg width="15" height="16" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.47688 20.01H0.330364V6.65703H4.47688V20.01ZM2.40139 4.83556C1.07547 4.83556 0 3.73732 0 2.4114C9.49038e-09 1.77451 0.253003 1.16371 0.703352 0.713361C1.1537 0.263013 1.7645 0.0100098 2.40139 0.0100098C3.03828 0.0100098 3.64908 0.263013 4.09943 0.713361C4.54978 1.16371 4.80278 1.77451 4.80278 2.4114C4.80278 3.73732 3.72687 4.83556 2.40139 4.83556ZM19.996 20.01H15.8584V13.5099C15.8584 11.9607 15.8271 9.97407 13.7025 9.97407C11.5467 9.97407 11.2163 11.6571 11.2163 13.3983V20.01H7.07426V6.65703H11.0511V8.4785H11.1092C11.6628 7.42937 13.015 6.3222 15.0325 6.3222C19.229 6.3222 20.0004 9.08566 20.0004 12.675V20.01H19.996Z"/>
          </svg>
        </div>
        
        <div class="social-btn" @click="share('link')">
          <div v-show="hasCopied" class="copied-msg">
            Copied to clipboard
          </div>
          <svg width="16" height="15" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5784 0.00020745C13.1395 -0.0122958 11.7533 0.540835 10.7183 1.54047L10.7088 1.54972L9.1357 3.11372C8.77748 3.46986 8.77579 4.04896 9.13193 4.40718C9.48807 4.7654 10.0672 4.76709 10.4254 4.41095L11.9936 2.85187C12.6831 2.18819 13.6053 1.82106 14.5625 1.82938C15.5217 1.83771 16.4393 2.22247 17.1176 2.90078C17.7959 3.57909 18.1807 4.49668 18.189 5.45592C18.1973 6.41266 17.8305 7.33448 17.1674 8.02389L14.4295 10.7618L14.4293 10.7619C14.0585 11.133 13.6121 11.4199 13.1206 11.6032C12.6291 11.7866 12.1039 11.8621 11.5806 11.8246C11.0573 11.7871 10.5482 11.6376 10.0879 11.386C9.62748 11.1345 9.22659 10.7869 8.91236 10.3668C8.60979 9.96233 8.03662 9.8797 7.63213 10.1823C7.22763 10.4848 7.14501 11.058 7.44757 11.4625C7.91891 12.0926 8.52026 12.614 9.21082 12.9913C9.90139 13.3686 10.665 13.5929 11.4499 13.6492C12.2348 13.7054 13.0226 13.5921 13.7599 13.3171C14.4972 13.0421 15.1667 12.6117 15.723 12.0552L18.4668 9.31143L18.4779 9.30009C19.4775 8.2651 20.0307 6.87889 20.0182 5.44003C20.0057 4.00117 19.4285 2.62478 18.4111 1.60731C17.3936 0.589847 16.0172 0.0127107 14.5784 0.00020745ZM8.56846 6.35063C7.78356 6.29441 6.99575 6.40766 6.25847 6.68269C5.52124 6.9577 4.85165 7.38815 4.29535 7.94463L1.55161 10.6884L1.54047 10.6997C0.540835 11.7347 -0.0122958 13.1209 0.00020745 14.5598C0.0127107 15.9986 0.589848 17.375 1.60731 18.3925C2.62478 19.4099 4.00117 19.9871 5.44003 19.9996C6.87889 20.0121 8.2651 19.459 9.30009 18.4593L9.31143 18.4482L10.8754 16.8842C11.2326 16.527 11.2326 15.9479 10.8754 15.5907C10.5182 15.2335 9.93914 15.2335 9.58196 15.5907L8.02388 17.1488C7.33447 17.8119 6.41265 18.1787 5.45592 18.1704C4.49668 18.1621 3.57909 17.7773 2.90078 17.099C2.22247 16.4207 1.83771 15.5031 1.82938 14.5439C1.82106 13.5871 2.18787 12.6653 2.851 11.9759L5.58905 9.23786C5.95993 8.86684 6.40627 8.57992 6.8978 8.39657C7.38932 8.21322 7.91452 8.13772 8.43779 8.17519C8.96106 8.21267 9.47014 8.36224 9.93052 8.61377C10.3909 8.86529 10.7918 9.21289 11.106 9.63297C11.4086 10.0375 11.9818 10.1201 12.3863 9.81753C12.7907 9.51497 12.8734 8.94179 12.5708 8.5373C12.0995 7.90717 11.4981 7.38578 10.8076 7.00849C10.117 6.6312 9.35336 6.40684 8.56846 6.35063Z"/>
          </svg>
        </div>

      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: ['shareUrl', 'shareMessage', 'story'],

    data() {
      return {
        expanded: false,
        hasCopied: false
      }
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },
    },

    methods: {
      expand() {
        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'link',
              article: this.story.node,
              story: this.story.slug,
              heading: this.shareMessage,
            }
          });
          return;
        } else {
          this.expanded = !this.expanded;
        }
      },

      share(type) {
        // console.log("PROPS", this.$props)
        let newFacebookWindow;
        let newTwitterWindow;
        let newLinkedInWindow;
        let link = `https://nourished.news${this.shareUrl}`;
        let buildTweet = this.shareMessage ?? `Hey! I've discovered OneSub, a new, better way to read the news. Come check it out!`;

        let linkedInUrl;
        let facebookUrl;
        let twitterUrl;
        let dummy = document.createElement('input');

        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'socialCallback',
            data: {
              social: 'link',
              article: this.story.node,
              story: this.story.slug,
              heading: this.shareMessage,
            }
          });
          return;
        }

        switch (type) {
          case 'twitter':
            twitterUrl = `https://twitter.com/share?text=${buildTweet}&url=${link}`;
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'twitter',
                  type: 'link',
                  link: twitterUrl
                }
              });
            } else {
              newTwitterWindow = window.open(`${twitterUrl}`, '_blank');
              if (newTwitterWindow) {
                newTwitterWindow.focus();
              }
            }
            break;
          case 'facebook':
            facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'facebook',
                  type: 'link',
                  link: facebookUrl
                }
              });
            } else {
              newFacebookWindow = window.open(`${facebookUrl}`, '_blank');
              if (newFacebookWindow) {
                newFacebookWindow.focus();
              }
            }
            break;
          case 'linkedin':
            linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${link}`
            if (this.hasApp) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'linkedin',
                  type: 'link',
                  link: linkedInUrl
                }
              });
            } else {
              newLinkedInWindow = window.open(`${linkedInUrl}`, '_blank');
              if (newLinkedInWindow) {
                newLinkedInWindow.focus();
              }
            }
            break
          case 'link':
            if (this.hasApp && this.story) {
              this.EventBus.$emit("appCallback", {
                type: 'socialCallback',
                data: {
                  social: 'link',
                  article: this.story.article,
                  story: this.story.story,
                  heading: this.shareMessage,
                }
              });
            } else {
              document.body.appendChild(dummy);
              dummy.value = link;
              dummy.select();
              document.execCommand('copy');
              document.body.removeChild(dummy);
              this.hasCopied = true;
              setTimeout(() => {
                this.hasCopied = false;
              }, 4000);
              break;
            }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .share-action,
  .social-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    cursor: pointer;
  }

  .social-btn {
    width: 35px;
  }

  .share-wrapper {
    position: relative;
    display: flex;
    align-items: center;

    .share-action {
      background: $neutral-500;
      margin-right: 0.5rem;
      width: unset;
      border-radius: 500px;
      padding: 0 1.2rem;
      transform: translate3d(0, 0, 0);
      backface-visibility: hidden;
      // animation-name: shakeMe;
      // animation-duration: 5s;
      // animation-iteration-count: infinite;
      // animation-timing-function: linear;

      p {
        font-size: 0.85rem;
        font-weight: bold;
        margin-left: 0.5rem;
        padding-bottom: 2px;
      }

      .darkmode & {
        background: $neutral-300;
      }

      svg {
        margin-bottom: 2px;

        path {
          fill: $neutral-400;
          @include transition;
        }
      }

      &.expanded {
        svg path {
          fill: $neutral-100;

          .darkmode & {
            fill: $neutral-600;
          }
        }
      }
    }

    .share-expanded {
      display: flex;
      align-items: center;
      flex: 1;
      margin-right: 0.5rem;
    }

    .social-btn {     
      svg path {
        fill: $neutral-100;
      }

      .darkmode & {
        svg path {
          fill: $neutral-600;
        }
      }
    }

    .copied-msg {
      position: absolute;
      bottom: 0;
      top: 0;
      right: 0;
      padding: 0.7rem 1rem 0.6rem 1rem;
      width: 100%;
      font-size: 0.8rem;
      font-weight: bold;
      text-align: center;
      border-radius: 500px;
      background: rgba($neutral-400, 0.95);
      z-index: 999;
      box-shadow: 0 0 20px 0 rgba($neutral-100, 0.2);
      @include transition;
      color: $neutral-600;

      .darkmode & {
        color: $neutral-100;
      }
    }
  }

  .mobile.is-app {
    .share-action {
      svg path {
        fill: $neutral-100;
      }

      .darkmode & {
        svg path {
          fill: $neutral-600;
        }
      }
    }
  }


  @keyframes shakeMe {
    2%, 18% {
        transform: translate3d(-5px, 0, 0);
    }

    4%, 16% {
        transform: translate3d(5px, 0, 0);
    }

    6%, 10%, 14% {
        transform: translate3d(-5px, 0, 0);
    }

    8%, 12% {
        transform: translate3d(5px, 0, 0);
    }
    
    18.1% {
        transform: translate3d(0px, 0, 0);
    }
  }
</style>